import * as React from "react";
import { styled } from "@mui/material";
import { CommonColors } from "../colors/commonColors";
import clsx from "clsx";

//region [[ Styles ]]

const KahunTitleCardView = styled("div")({
  background: CommonColors.White,
  display: "flex",
  flexFlow: "column",
  padding: "0",
  margin: "22px",
  borderRadius: "8px",
  boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.1)",
  position: "relative",
});

const TitleCardTopTitle = styled("div")({
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  background: CommonColors.PrimaryLight,
  padding: "15px 25px",
  display: "flex",
  flexFlow: "row",
  alignItems: "flex-start",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 15,
  color: CommonColors.Primary,
  minHeight: "61px",
});

const TitleCardContent = styled("div")({
  padding: "21px",
  flex: 1,
  flexFlow: "row",
  alignItems: "flex-start",
  justifyContent: "center",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface KahunTitleCardProps {
  className?: string;
  title?: React.ReactNode;
  children: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const KahunTitleCard = ({ ...props }: KahunTitleCardProps) => {
  return (
    <KahunTitleCardView className={clsx("kahun-title-card", props.className)}>
      {!!props.title && <TitleCardTopTitle>{props.title}</TitleCardTopTitle>}
      <TitleCardContent>{props.children}</TitleCardContent>
    </KahunTitleCardView>
  );
};
